<template>
    <div class="topbar-container">
        <div class="line"></div>
        <div class="container-wrap">
            <div class="mybeans-wrap bh">
                <div class="bh bstart b1">
                    <div class="ico-maintenance bg-contain"></div>我的车主币：
                    <div class="mybeansColor">{{$store.getters.unusedPoints}}</div>
                </div>
                <div>
                    <van-button class="btn btn-goodbuy" @click="go('MoneyHome')">
                        <div class="fz_28">提现</div>
                    </van-button>
                </div>
            </div>
            <div class="title bh bstart fz_28">
                <zbTime
                    :options="timeOptions"
                    class="time-cell"
                    showFormat="YYYY-MM"
                    v-model="timeValue"
                ></zbTime>
                <div class="tr b1 fz_28">支出：{{money.payPoints||0}}&ensp;收入：{{money.getPoints||0}}</div>
            </div>
        </div>
        <zbList v-model="store" class="v-list" v-slot:default="{ item }" @reLoad="reLoadStore">
            <div class="item shadow-bg">
                <div class="bh">
                    <div class="b1 text fz_30">{{item.type}}</div>
                    <span class="fz_32" :class="item.cls">{{item.pointsShow}}</span>
                </div>
                <div class="time fz_26">{{item.insertAt}}</div>
            </div>
        </zbList>
    </div>
</template>
<script>
import { getCouponsMonthCount, getCouponsMonthList } from "@/api/user";
import { list } from "@/mixin/list";
import { user } from "@/mixin/user";
import zbList from "@/components/data/List";
import zbTime from "@/components/input/DateTime";
import moment from "moment";
export default {
    mixins: [list, user],
    name: "UserIntegral",
    components: { zbList, zbTime },
    data() {
        return {
            timeOptions: {
                type: "year-month",
                minDate: new Date(2018, 12, 30),
                maxDate: new Date()
            },
            store: {
                proxy: {
                    pageParam: "currentPage",
                    getList: getCouponsMonthList,
                    disposeItem(item) {
                        let pointsShow = item.points,
                            cls = "lose";
                        if (item.points > 0) {
                            pointsShow = "+" + pointsShow.toString();
                            cls = "just";
                        }
                        item.pointsShow = pointsShow;
                        item.cls = cls;
                    }
                }
            },
            // 统计数据
            money: {
                spending: 0,
                income: 0
            },
            maxDate: "",
            timeValue: new Date(),
            dataPrams: {}
        };
    },
    watch: {
        timeValue: {
            handler(v) {
                if (v) {
                    this.loadData(
                        moment(v).format("YYYY"),
                        moment(v).format("MM")
                    );
                }
            }
        }
    },
    methods: {
        // 获取用户数据后执行
        userLoginend() {
            const date = new Date();
            this.loadData(
                moment(date).format("YYYY"),
                moment(date).format("MM")
            );
        },
        // 根据月加载数据
        loadData(year, month) {
            const me = this,
                params = { month: month, year: year };
            me.dataPrams = params;
            me.getCount(params);
            me.storeLoad(params);
            // 保存月份条件
            me.month = month;
        },
        // 获取统计数据
        getCount(params) {
            getCouponsMonthCount(params).then(res => {
                const money = res.data;
                money.payPoints = Math.abs(money.payPoints);
                this.money = money;
            });
        },
        // 重载数据
        reLoadStore() {
            this.getCount(this.dataPrams);
        }
    }
};
</script>
<style scoped lang="scss">
.container-wrap {
    padding: 0 30px;
    background-color: #fff;
}
.line {
    background-color: #f1f2f3;
}
.mybeans-wrap {
    padding: 30px 0;
    .ico-maintenance {
        height: 36px;
        width: 36px;
        margin-right: 20px;
    }
    .mybeansColor {
        color: #ff9a2b;
    }
    .btn-goodbuy {
        width: 160px;
        height: 68px;
    }
}

.time-cell {
    /deep/ .van-cell {
        padding: 0 0 0 10px;
        border: 1px solid transparent;
        &:hover {
            border: 1px solid #ff9a2b;
        }
        &:not(:last-child):after {
            border: 0;
        }
    }
}
[data-theme="app"] {
    .time-cell {
        /deep/.van-cell {
            &:hover {
                border: 1px solid #c30d23;
            }
        }
    }
}
.title {
    padding: 30px 0;
    border-top: 1px solid #dcdcdc;
    background-color: #fff;
}
.v-list {
    background-color: #f7f8f8;
    height: calc(100% - 275px);
    /deep/ .list-item {
        padding: 30px 30px 0 30px;
        &:last-child {
            padding: 30px;
        }
    }
    .item {
        @include border-radius(8px);
        padding: 30px;
        .text {
            color: #000;
        }
        .time {
            color: #8b8a8a;
        }
        .just {
            color: #ff9a2b;
        }
        .lose {
            color: #33325c;
        }
    }
}
</style>
